function a(e, t) {
  for (var n = -1, l = e == null ? 0 : e.length, r = Array(l); ++n < l; )
    r[n] = t(e[n], n, e);
  return r;
}
var u = a;
export {
  u as _
};
